export function toCurrencyString(amount) {
    if (amount) {
        return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €';
    } else {
        return '0 €';
    }
}